<template>
    <div>
        <Dialog :visible.sync="exibirModal" header="Filtrar Funcionário com Pontos duplicados" :modal="true" :style="{width: '70vw'}" @hide="fecharModal">      
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-col-12 p-md-12" v-if="progresso > 0"> 
                Aguarde! Filtrando ponto...<i class="pi pi-spin pi-spinner" ></i>
                <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>
            </div> 
        </div>
            
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-6 p-mr-2">
                <div class="p-inputgroup">
                    <InputText v-model.trim="crachaNome" 
                    @keyup.enter="filtrar('PESQUISAR')" 
                    @keyup="crachaNome = crachaNome.replace(/[^0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]/g, ' ')" 
                    placeholder="crachá/pis/cpf/nome"/>
                    <Button icon="pi pi-search" title="Pesquisar" @click="filtrar('PESQUISAR')"/>                    
                </div>
            </div>             
            <div class="p-field p-col-0"> 
                <Button label="Todos" icon="pi pi-search" @click="filtrar('BUCAR_COM_CENTRO_CUSTO')"/>
            </div> 
            <div class="p-field p-col-0 p-ml-4" v-if="funcionarios.length > 0"> 
                <Button label="Resolver Todos" icon="pi pi-check" class="p-button-danger p-mr-2" @click="resolverTodos"/>
            </div> 
        </div>
        <DataTable :value="funcionarios" :filters="filtro" :paginator="true" :rows="10"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
            class="p-datatable-sm p-datatable-striped">                     
            <Column field="cracha" header="Crachá"></Column>
            <Column field="nome" header="Nome"></Column>    
            <Column>
            <template #body="slotProps">
                <Button icon="pi pi-eye" label="Marcações" title="Marcações" class="p-button-rounded p-button-info p-mr-2" @click="marcacoes(slotProps.data)"/>  
                <Button icon="pi pi-check" label="Resolver" title="Marcações" class="p-button-rounded p-button-danger p-mr-2" @click="resolver(slotProps.data)"/>                                    
            </template>
            </Column>		
        </DataTable>	
        <h2 v-if="exibirAvisoTudoOK">Tudo OK! Sem pontos duplicados.</h2>
            <template #footer>
                <div class="p-d-flex p-jc-between">
                    <div></div>
                    <div>
                        <Button label="OK" icon="pi pi-check" @click="fecharModal" />
                    </div>                              
                </div>            
            </template>        
        </Dialog>
    </div>
</template>
  
  <script>
  import ControlePontoService from '@/service/ControlePontoService';
  import { exibirMensagem } from '@/global';
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
      controlePontoService: null,
      data() {
          return {
            exibirModal: false,
            exibirAvisoTudoOK: false,
            funcionarios: [],
            filtro: {},
            progresso: 0,
            requisicao: null,
            crachaNome: '',
            pararTimeout: false,
          }
      },
      methods: {
          ...mapGetters('sessao', ['getDadosRequisicao']),
          ...mapActions('funcionario', ['inluirDadosMarcacoes']),
          /**
           * 
           */
          iniciar(requisicao) {           
            this.requisicao = {...requisicao};
            this.exibirAvisoTudoOK = false;
            this.exibirModal = true;
          },
          /**
           * 
           */
          filtrar(btn) {
            this.funcionarios = [];
            this.requisicao.crachaNome = this.crachaNome;
            if(btn == 'BUCAR_COM_CENTRO_CUSTO') {
               this.requisicao.crachaNome = '';
            }
            this.exibirAvisoTudoOK = false;
            this.controlePontoService.buscarQuantidadeFuncionarios(this.requisicao)
            .then(resp => { 
                let limiteLista = 50;
                let totalFuncionarios = resp.data.totalFuncionarios;
                let qtdRequisicoes = parseInt(totalFuncionarios/limiteLista);
                qtdRequisicoes += (totalFuncionarios%limiteLista > 0 ? 1 : 0);   
                let requisicoes = [];
                for(let i = 0; i < qtdRequisicoes; i++) {
                    let req = {...this.requisicao};
                    req.numPagina = (i+1);
                    req.qtdLinhas = 50;
                    requisicoes.push(req);
                }
                this.progresso = 1;             
                this.filtrarRecursivo(1, requisicoes);
            })
            .catch(erro => { exibirMensagem(this, erro)}); 
          },
          /**
           * 
           */
          filtrarRecursivo(pagina, requisicoes) {
            if(this.pararTimeout) {
                return;
            }
            let requisicao = requisicoes[(pagina-1)];          
            this.controlePontoService.buscarPontoDuplicado(requisicao, 'fdb=f')
            .then(resp => {
                resp.data.forEach(funcionario => {
                    this.funcionarios.push(funcionario);
                });
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    setTimeout(() => { this.progresso = 0; }, 1000);
                    if(this.funcionarios.length == 0) {
                        this.exibirAvisoTudoOK = true;
                    }
                    sessionStorage.setItem('FUNCIONARIOS_PONTO_DUPLICADO', JSON.stringify(this.funcionarios));
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.filtrarRecursivo(pagina, requisicoes);
                    }, 200);
                } 
            })
            .catch(erro => {        
                this.exibirAvisoTudoOK = false;           
                exibirMensagem(this, erro);
                setTimeout(() => { this.progresso = 0; }, 3000);
            });
          },
          /**
           * 
           * @param {*} funcionario 
           */
           resolver(funcionario) {            
            this.requisicao['idsFuncionarios'] = [funcionario.id];  
            this.controlePontoService.resolverPontoDuplicado(this.requisicao)
            .then(resp => { 
                this.resolvido(funcionario);
                exibirMensagem(this, resp);
            })
            .catch(erro => { exibirMensagem(this, erro)}); 
          },
          /**
           * 
           */
          resolverTodos() {  
            let req = {...this.requisicao};
            req['idsFuncionarios'] = [];
            let requisicoes = [];
            requisicoes.push(req);
            let maximo = 50;
            let qtd = 0;           
            this.funcionarios.forEach(funcio => {
                if(qtd < maximo) {
                    qtd++;
                } else {
                    qtd = 1;                    
                    req = {...this.requisicao};
                    req['idsFuncionarios'] = [];
                    requisicoes.push(req);
                }
                req.idsFuncionarios.push(funcio.id);
            });
            this.resolverTodosRecursivo(1, requisicoes);
          },
          /**
           * 
           */
          resolverTodosRecursivo(pagina, requisicoes) {
            if(this.pararTimeout) {
                return;
            }
            let requisicao = requisicoes[(pagina-1)];   
            this.controlePontoService.resolverPontoDuplicado(requisicao, 'fdb=f')
            .then(resp => {
                if((pagina + 1) > requisicoes.length) {                       
                    this.progresso = 100;
                    setTimeout(() => { this.progresso = 0; }, 1000);
                    this.funcionarios = [];
                    this.exibirAvisoTudoOK = true; 
                    exibirMensagem(this, resp);
                } else  {
                    this.progresso = Math.trunc((pagina / requisicoes.length)*100);
                    pagina++;
                    setTimeout(() => {
                        this.resolverTodosRecursivo(pagina, requisicoes);
                    }, 200);
                } 
            })
            .catch(erro => {                  
                exibirMensagem(this, erro);
                setTimeout(() => { this.progresso = 0; }, 3000);
            });
          },
          /**
           * 
           */
          resolvido(funcionario) {
            let index = 0;
            let encontrou = false;
            this.funcionarios.forEach((funcio,i) => {
                if(funcio.id == funcionario.id) {
                    index = i;
                    encontrou = true;
                }
            });
            if(encontrou) {
                this.funcionarios.splice(index, 1);
            }
          },
          /**
           * 
           */
          marcacoes(funcionario) {
            let dados = {
               mesAno: this.requisicao.mesAno,
               funcionario: funcionario,
               cnpj: this.requisicao.cnpj
            };
            this.inluirDadosMarcacoes(dados);
            this.$router.push('/movimento/controle-ponto/marcacoes');
          },
          /**
           * 
           */
          fecharModal() {             
              this.exibirModal = false;                    
          }
      },
      created() {
          this.controlePontoService = new ControlePontoService();
          let json = JSON.parse(sessionStorage.getItem('FUNCIONARIOS_PONTO_DUPLICADO'));
          if(json) {
            this.funcionarios = json;
          }
      },
      beforeDestroy() {
        this.pararTimeout = true;
      }
  }
  </script>
  
  <style>
  
  </style>